import {inject, Injectable, Type} from '@angular/core';
import {DialogService} from "primeng/dynamicdialog";
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Injectable({
  providedIn: 'root'
})
export class HomeyDialogService {
  private readonly dialogService = inject(DialogService);

  public showDialogWithHeader<T, InputValuesType extends Record<string, any> = {}>(componentType: Type<T>, header: string, inputValues: InputValuesType): DynamicDialogRef<T> | null {
    return this.dialogService.open(
      componentType,
      {
        header: header,
        closable: true,
        modal: true,
        focusOnShow: false,
        width: 'calc(min(100vw - 10px, 500px))',
        inputValues
      }
    )
  }
}
